import { DBAS, LEADS, STATUSES } from '../../api/endpoints';
import { baseApi, listTags } from './baseApi';

export const merchantsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getDBAs: build.query({
      query: (params = {}) => ({ url: DBAS.LIST, method: 'GET', params }),
      providesTags: (result) => listTags('Merchant', result),
    }),
    getDBAById: build.query({
      query: (id) => ({ url: DBAS.BY_ID(id), method: 'GET' }),
      providesTags: (_r, _e, id) => [{ type: 'Merchant', id }],
    }),
    submitAllStepperData: build.mutation({
      query: (payload) => ({ url: DBAS.LIST, method: 'POST', data: payload }),
      invalidatesTags: [{ type: 'Merchant', id: 'LIST' }],
    }),
    updateDBA: build.mutation({
      query: ({ id, dbaData }) => ({
        url: DBAS.BY_ID(id),
        method: 'PUT',
        data: dbaData,
      }),
      invalidatesTags: (_r, _e, { id }) => [
        { type: 'Merchant', id },
        { type: 'Merchant', id: 'LIST' },
      ],
    }),
    getDbaStatus: build.query({
      query: (params = {}) => ({ url: STATUSES.LIST, method: 'GET', params }),
      providesTags: [{ type: 'Status', id: 'DBA' }],
    }),
    updateDbaProcessStatus: build.mutation({
      query: ({ id, statusId }) => ({
        url: DBAS.PROCESS_STATUS(id),
        method: 'PUT',
        data: { status_id: statusId },
      }),
      invalidatesTags: (_r, _e, { id }) => [
        { type: 'Merchant', id },
        { type: 'Merchant', id: 'LIST' },
      ],
    }),
    updateDbaStatus: build.mutation({
      query: ({ id, status }) => ({
        url: DBAS.STATUS(id),
        method: 'PUT',
        data: { status },
      }),
      invalidatesTags: (_r, _e, { id }) => [
        { type: 'Merchant', id },
        { type: 'Merchant', id: 'LIST' },
      ],
    }),
    assignDbaToUser: build.mutation({
      query: ({ id, userId }) => ({
        url: DBAS.REASSIGN(id),
        method: 'PUT',
        data: { user_id: userId },
      }),
      invalidatesTags: (_r, _e, { id }) => [
        { type: 'Merchant', id },
        { type: 'Merchant', id: 'LIST' },
      ],
    }),
    deleteDba: build.mutation({
      query: (id) => ({ url: DBAS.BY_ID(id), method: 'DELETE' }),
      invalidatesTags: (_r, _e, id) => [
        { type: 'Merchant', id },
        { type: 'Merchant', id: 'LIST' },
      ],
    }),
    getLeadsForMerchant: build.query({
      query: (params = {}) => ({ url: LEADS.LIST, method: 'GET', params }),
      providesTags: (result) => listTags('Lead', result),
    }),
  }),
});

export const {
  useGetDBAsQuery,
  useLazyGetDBAsQuery,
  useGetDBAByIdQuery,
  useLazyGetDBAByIdQuery,
  useSubmitAllStepperDataMutation,
  useUpdateDBAMutation,
  useGetDbaStatusQuery,
  useLazyGetDbaStatusQuery,
  useUpdateDbaProcessStatusMutation,
  useUpdateDbaStatusMutation,
  useAssignDbaToUserMutation,
  useDeleteDbaMutation,
  useGetLeadsForMerchantQuery,
  useLazyGetLeadsForMerchantQuery,
} = merchantsApi;
